import { useEffect, useMemo, useState } from "react"
import { useApi } from "../../hooks/use-api"
import { API_SCHOOL_DETAILS } from "../../utils/api-routes"

const useHandler = () =>{
    const {get} = useApi()
    const[schoolDetails,setSchooldetails] = useState({})
    const [search,setSearch] = useState("")
       const [loading, setLoading] = useState(false);
         const [data,setData] = useState({
    selectedSchools: {} 
  })

    const getSchoolManagementLisit = async() =>{
      setLoading(true);
       try{
         const res = await get(API_SCHOOL_DETAILS)
         if(res){
            setSchooldetails(res?.data)
         }
       }catch(e){
            console.log("Error getting from Get School api",e)
       } finally {
         setLoading(false);
       }
    } 

    const schoolList = useMemo(()=>{
        return schoolDetails?.schools?.filter(({school})=> school?.toLowerCase()?.includes(search.toLowerCase()))
    },[schoolDetails,search])


    useEffect(()=>{
       getSchoolManagementLisit()
    },[])

    const onChangeValue = (e) => setSearch(e.target.value)

        const refreshData = () => {
        getSchoolManagementLisit();
        setSearch("");
    };

      const handleCheckboxChange = (school) => {
  setData(prev => ({
    ...prev,
    selectedSchools: {
      ...prev.selectedSchools,
      [school]: !prev.selectedSchools[school]
    }
  }));
};

const getSelectedSchools = () =>
  Object.keys(data.selectedSchools).filter(
    school => data.selectedSchools[school]
  );

        const clearSelectedSchools = () =>{
        setData((prev)=> ({...prev,selectedSchools:{}}))
      }


   return{
     schoolList,
     search,
     setSearch,
     getSchoolManagementLisit,
     onChangeValue,
     refreshData,
     loading,
     handleCheckboxChange,
     getSelectedSchools,
     clearSelectedSchools,
     data
   }
}

export default useHandler